import { Step } from "src/ui/components/StepList/StepList";

export const addContextToExpectationManagementStep = (
  steps: Omit<Step, "context">[],
  userExperienceGroup: string
): Step[] => {
  return steps.map((step) => ({
    ...step,
    context: userExperienceGroup
  }));
};
